// Client-side export of the issues report until a server endpoint exists.
// Both formats are written as CSV; Excel gets a UTF-8 BOM, ';' separator and decimal comma so it
// opens directly with Swedish locale settings. Replace with a real .xlsx endpoint later.

import type { InsightsIssuesReportData } from './insights-dummy-data';

export type InsightsExportFormat = 'csv' | 'excel';

function toCsv(rows: (string | number)[][], separator: string, decimalComma: boolean): string {
    const escape = (value: string | number) => {
        const text = typeof value === 'number' && decimalComma ? String(value).replace('.', ',') : String(value);
        return /["\n\r;,]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
    };
    return rows.map((row) => row.map(escape).join(separator)).join('\r\n');
}

function download(content: string, fileName: string) {
    const url = URL.createObjectURL(new Blob([content], { type: 'text/csv;charset=utf-8' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
}

// month: yyyy-MM
export function exportInsightsIssuesReport(data: InsightsIssuesReportData, month: string, format: InsightsExportFormat) {
    const rows: (string | number)[][] = [
        ['Month', 'Mailings sent', 'Emails sent', 'Delivery rate %', 'Open rate %', 'Click rate %', 'Bounce rate %', 'Unsubscribe rate %', 'Inactive rate %'],
        ...data.MonthlyTrend.map((m) => [
            m.Month,
            m.IssueCount,
            m.SentCount,
            m.ReceivedPercentage,
            m.OpenPercentage,
            m.ClickPercentage,
            m.BouncePercentage,
            m.UnsubscribePercentage,
            m.InactivePercentage,
        ]),
    ];
    const isExcel = format === 'excel';
    const content = toCsv(rows, isExcel ? ';' : ',', isExcel);
    download(isExcel ? `﻿${content}` : content, `email-report-${month}.csv`);
}
